export enum API_STATUS {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export interface ApiResponseInfo {
  message?: string;
  details?: any;
}

export interface ApiOperation extends ApiResponseInfo {
  status: API_STATUS;
}

export enum IMPERSONATE_USER {
  SESSION_NAME = 'user'
}

export interface ReportsApiParamsTypes {
  token?: string;
  reportUrl?: string;
  timezone?: string;
}
